import type { AuthTranslations } from './types'

/**
 * Arabic translations for Auth domain
 */
export const arTranslations: AuthTranslations = {
  // Page/Section level
  title: "المصادقة",
  subtitle: "إدارة إعدادات المصادقة",

  // Actions
  addAuth: "إضافة مصادقة",
  editAuth: "تعديل المصادقة",
  deleteAuth: "حذف المصادقة",

  // Search and filters
  searchPlaceholder: "البحث في المصادقة...",
  noItemsFound: "لم يتم العثور على عناصر المصادقة",
  noItemsDescription: "لم تقم بإضافة أي عناصر مصادقة بعد.",
  addFirst: "أضف أول عنصر مصادقة",

  // Form section (basic)
  form: {
    name: "الاسم",
    namePlaceholder: "أدخل الاسم",
    status: "الحالة",
    validation: {
      nameRequired: "الاسم مطلوب",
    }
  },

  // Status
  status: {
    active: "نشط",
    inactive: "غير نشط",
  },

  // Messages
  messages: {
    createSuccess: "تم إنشاء المصادقة بنجاح",
    updateSuccess: "تم تحديث المصادقة بنجاح",
    deleteSuccess: "تم حذف المصادقة بنجاح",
    deleteConfirm: "هل أنت متأكد من حذف هذه المصادقة؟",
  },

  // Table headers
  table: {
    name: "الاسم",
    status: "الحالة",
  },

  // Login page
  signIn: "تسجيل الدخول",
  signUp: "إنشاء حساب",
  welcomeBack: "مرحباً بعودتك",
  loginSubtitle: "سجّل الدخول إلى بوابة عملاء الشركة المتحدة للأعلاف",
  enterCredentials: "أدخل بيانات الاعتماد للوصول إلى حسابك",
  rememberMe: "تذكرني",
  forgotPassword: "نسيت كلمة المرور؟",
  forgotPasswordDescription: "أدخل بريدك الإلكتروني وسنرسل لك رابط إعادة تعيين كلمة المرور",
  noAccount: "ليس لديك حساب؟",
  alreadyHaveAccount: "لديك حساب بالفعل؟",

  // Registration
  createAccount: "إنشاء حساب",
  registerSubtitle: "انضم إلى بوابة عملاء الشركة المتحدة للأعلاف اليوم",
  registrationSuccessful: "تم التسجيل بنجاح",
  registrationSuccessMessage: "تم إنشاء حسابك بنجاح",
  registrationPendingMessage: "شكراً للتسجيل. حسابك قيد الانتظار للتفعيل وستتمكن من تسجيل الدخول بمجرد الموافقة عليه.",
  fillDetails: "أدخل بياناتك لإنشاء حساب",
  fullName: "الاسم الكامل",
  fullNamePlaceholder: "أدخل اسمك الكامل",
  companyName: "اسم الشركة",
  companyNamePlaceholder: "أدخل اسم شركتك",
  phone: "رقم الهاتف",
  phonePlaceholder: "+966 5XX XXX XXXX",
  accountType: "نوع الحساب",
  selectAccountType: "اختر نوع الحساب",
  accountContractor: "مقاول",
  accountSupplier: "مورد",
  accountDistributor: "موزع",
  accountRetail: "عميل تجزئة",

  // Terms
  termsNotice: "بالمتابعة، فإنك توافق على",
  termsOfService: "شروط الخدمة",
  privacyPolicy: "سياسة الخصوصية",
  and: "و",
  agreeToTerms: "أوافق على",

  // Password reset
  resetPassword: "إعادة تعيين كلمة المرور",
  resetSubtitle: "سنساعدك على استعادة الوصول إلى حسابك",
  resetInstructions: "أدخل بريدك الإلكتروني وسنرسل لك رابطاً لإعادة تعيين كلمة المرور",
  sendResetLink: "إرسال رابط إعادة التعيين",
  backToLogin: "العودة لتسجيل الدخول",
  checkEmail: "تحقق من بريدك الإلكتروني",
  resetEmailSent: "تم إرسال رابط إعادة التعيين",
  resetEmailSentMessage: "أرسلنا رابط إعادة تعيين كلمة المرور إلى {{email}}",
  didntReceiveEmail: "لم تستلم البريد؟ تحقق من مجلد الرسائل غير المرغوب فيها أو حاول مرة أخرى.",
  tryAgain: "حاول مرة أخرى",
  passwordResetSuccessful: "تم إعادة تعيين كلمة المرور بنجاح",
  passwordResetSuccessMessage: "تم إعادة تعيين كلمة المرور الخاصة بك بنجاح",
  resetPasswordDescription: "أدخل كلمة المرور الجديدة أدناه",
  newPassword: "كلمة المرور الجديدة",
  currentPassword: "كلمة المرور الحالية",

  // Toasts / notifications
  loginSuccess: "تم تسجيل الدخول بنجاح",
  loginSuccessMessage: "مرحباً بعودتك",
  loginError: "فشل تسجيل الدخول",
  registerSuccess: "تم إنشاء الحساب بنجاح",
  registerError: "فشل إنشاء الحساب",
  logoutSuccess: "تم تسجيل الخروج",
  logoutSuccessMessage: "تم تسجيل خروجك",
  passwordResetSent: "تم إرسال رابط إعادة التعيين",
  passwordResetError: "فشل إعادة التعيين",
  passwordResetSuccess: "تم تحديث كلمة المرور",
  changePasswordSuccess: "تم تحديث كلمة المرور",
  changePasswordSuccessMessage: "تم تغيير كلمة المرور بنجاح.",
  changePasswordError: "فشل تغيير كلمة المرور",
  changePasswordOtpSent: "تم إرسال رمز التحقق",
  changePasswordOtpError: "تعذر إرسال رمز التحقق",

  // Form fields
  email: "البريد الإلكتروني",
  emailPlaceholder: "أدخل بريدك الإلكتروني",
  emailOrPhone: "البريد الإلكتروني أو رقم الهاتف",
  emailOrPhonePlaceholder: "أدخل بريدك الإلكتروني أو رقم هاتفك",
  password: "كلمة المرور",
  passwordPlaceholder: "أدخل كلمة المرور",
  confirmPassword: "تأكيد كلمة المرور",
  confirmPasswordPlaceholder: "أكد كلمة المرور",
  passwordsDoNotMatch: "كلمات المرور غير متطابقة",

  // Buttons
  buttons: {
    signIn: "تسجيل الدخول",
    signUp: "إنشاء حساب",
    forgotPassword: "نسيت كلمة المرور",
    resetPassword: "إعادة تعيين كلمة المرور",
    backToLogin: "العودة لتسجيل الدخول",
  },

  // Standalone convenience keys (duplicates of nested keys for easier access)
  name: "الاسم",
  namePlaceholder: "أدخل الاسم",
  statusLabel: "الحالة",
  nameRequired: "الاسم مطلوب",
  active: "نشط",
  inactive: "غير نشط",
  createSuccess: "تم إنشاء المصادقة بنجاح",
  updateSuccess: "تم تحديث المصادقة بنجاح",
  deleteSuccess: "تم حذف المصادقة بنجاح",
  deleteConfirm: "هل أنت متأكد من حذف هذه المصادقة؟",

  // Registration — new fields
  mobilePhone: 'رقم الجوال',
  mobilePhonePlaceholder: '+966 5XX XXX XXXX',
  telephone: 'رقم الهاتف',
  telephonePlaceholder: '+966 1XX XXX XXXX',
  vatNumber: 'رقم ضريبة القيمة المضافة',
  vatNumberPlaceholder: '3XXXXXXXXXX3',
  addressLine1: 'عنوان الشارع',
  addressLine1Placeholder: 'اسم الشارع',
  houseNumber: 'رقم المبنى',
  city: 'المدينة',
  cityPlaceholder: 'مثال: الرياض',
  region: 'المنطقة',
  postalCode: 'الرمز البريدي',
  country: 'الدولة',
  selectCountry: 'اختر الدولة',
  selectRegion: 'اختر المنطقة',
  vatSection: 'معلومات ضريبة القيمة المضافة',
  crSection: 'السجل التجاري',
  crNumber: 'رقم السجل التجاري',
  addressSection: 'العنوان',
  vatCertificate: 'شهادة ضريبة القيمة المضافة',
  vatCertificateHint: 'ارفع شهادة ضريبة القيمة المضافة الرسمية (PDF أو صورة)',
  crDocument: 'السجل التجاري',
  crDocumentHint: 'ارفع شهادة السجل التجاري (PDF أو صورة)',
  selectCity: 'اختر المدينة',
  chooseFile: 'اختر ملفًا',
  attachments: 'المستندات',
  attachmentsHint: 'ارفع شهادة ضريبة القيمة المضافة والسجل التجاري',
  addDocument: 'إضافة مستند',
  businessSegment: 'قطاع الأعمال',
  customerSegment: 'فئة العميل',
  customerSegmentHint: 'اختر الفئة التي تصف نوع عملك بشكل أفضل.',
  selectSegment: 'اختر الفئة',
  segmentTransport: 'النقل',
  segmentPlants: 'المصانع',
  segmentBagCustomers: 'عملاء الأكياس',
  regionRiyadh: 'الرياض',
  regionMakkah: 'مكة المكرمة',
  regionMadinah: 'المدينة المنورة',
  regionQassim: 'القصيم',
  regionEastern: 'المنطقة الشرقية',
  regionAsir: 'عسير',
  regionTabuk: 'تبوك',
  regionHail: 'حائل',
  regionNorthernBorders: 'الحدود الشمالية',
  regionJazan: 'جازان',
  regionNajran: 'نجران',
  regionBahah: 'الباحة',
  regionJawf: 'الجوف',
  accountInfo: 'معلومات الحساب',
  companyDetails: 'تفاصيل الشركة',
  companyDetailsSubtitle: 'أدخل بيانات شركتك وعنوانها',
  nextStep: 'التالي',
  back: 'رجوع',

  // API error keys returned by the backend as i18n keys
  errors: {
    invalidCredentials: "البريد الإلكتروني/رقم الهاتف أو كلمة المرور غير صحيحة",
    accountLocked: "تم قفل حسابك بسبب محاولات تسجيل دخول فاشلة متعددة. أعد تعيين كلمة المرور أو تواصل مع المسؤول.",
    emailNotConfirmed: "لم يتم تأكيد بريدك الإلكتروني",
    accountBlocked: "تم حظر حسابك من قِبل المسؤول",
    accountInactive: "تم تعطيل حسابك من قِبل المسؤول",
    noTenant: "حسابك غير مرتبط بمؤسسة بعد",
    accountPending: "حسابك غير نشط بعد. يرجى الانتظار حتى يتم تفعيله.",
    accountSuspended: "تم تعليق حسابك من قِبل المسؤول",
    registerDisabled: "التسجيل معطّل حالياً",
    emailAlreadyTaken: "البريد الإلكتروني أو اسم المستخدم مسجّل مسبقاً",
    phoneTaken: "رقم الهاتف مسجّل مسبقاً",
    sapBusinessPartnerNumberTaken: "رقم شريك الأعمال في SAP مسجّل مسبقاً",
    phoneInvalid: "يرجى إدخال رقم هاتف سعودي صحيح",
    vatCertificateRequired: "ملف شهادة ضريبة القيمة المضافة مطلوب",
    crDocumentRequired: "مستند السجل التجاري مطلوب",
    loginFailed: "فشل تسجيل الدخول. يرجى المحاولة مجدداً.",
    registrationFailed: "فشل التسجيل. يرجى المحاولة مجدداً.",
    deleteAccountFailed: "فشل حذف الحساب. يرجى المحاولة مجدداً.",
    updateProfileFailed: "فشل تحديث الملف الشخصي. يرجى المحاولة مجدداً.",
    passwordChangeFailed: "فشل تغيير كلمة المرور. يرجى المحاولة مجدداً.",
    verificationCodeFailed: "فشل طلب رمز التحقق. يرجى المحاولة مجدداً.",
    passwordResetRequestFailed: "فشل طلب إعادة تعيين كلمة المرور. يرجى المحاولة مجدداً.",
    passwordResetFailed: "فشل إعادة تعيين كلمة المرور. يرجى المحاولة مجدداً.",
  },

  // API success keys returned by the backend as i18n keys
  success: {
    registrationPending: "تم استلام طلب التسجيل. سيتم تفعيل حسابك قبل أن تتمكن من تسجيل الدخول.",
  },

  // Account action results
  deleteAccountSuccess: "تم حذف الحساب",
  deleteAccountFailed: "فشل حذف الحساب",
  updateProfileSuccess: "تم تحديث الملف الشخصي",
  updateProfileSuccessDesc: "تم حفظ التغييرات بنجاح.",
  updateProfileFailed: "فشل تحديث الملف الشخصي",

  // Lockout
  accountLocked: "تم قفل الحساب. أعد تعيين كلمة المرور أو تواصل مع المسؤول.",
  attemptsRemaining: "هذه هي المحاولة الأخيرة قبل قفل الحساب.",

  // Session timeout
  sessionExpired: "انتهت الجلسة",
  sessionExpiredMessage: "تم تسجيل خروجك بسبب عدم النشاط.",

  // Validation
  validation: {
    fullNameRequired: "الاسم الكامل مطلوب",
    companyNameRequired: "اسم الشركة مطلوب",
    emailRequired: "البريد الإلكتروني الصحيح مطلوب",
    passwordMin: "يجب أن تتكون كلمة المرور من 6 أحرف على الأقل",
    passwordMismatch: "كلمات المرور غير متطابقة",
    agreeToTermsRequired: "يجب الموافقة على الشروط",
    currentPasswordRequired: "كلمة المرور الحالية مطلوبة",
    passwordRequired: "كلمة المرور مطلوبة",
    passwordMinLength: "يجب أن تتكون كلمة المرور من 6 أحرف على الأقل",
    passwordMaxLength: "يجب ألا تزيد كلمة المرور عن 100 حرف",
    confirmPasswordRequired: "تأكيد كلمة المرور مطلوب",
    passwordsMismatch: "كلمات المرور غير متطابقة",
    countryRequired: 'الدولة مطلوبة',
    customerSegmentRequired: 'فئة العميل مطلوبة',
    vatNumberRequired: 'رقم ضريبة القيمة المضافة مطلوب',
    vatCertificateRequired: 'ملف شهادة ضريبة القيمة المضافة مطلوب',
    crNumberRequired: 'رقم السجل التجاري مطلوب',
    crDocumentRequired: 'مستند السجل التجاري مطلوب',
    addressLine1Required: 'العنوان مطلوب',
    houseNumberInvalid: 'يجب أن يكون رقم المبنى حتى 4 أرقام',
    cityRequired: 'المدينة مطلوبة',
    regionRequired: 'المنطقة مطلوبة',
    postalCodeRequired: 'الرمز البريدي مطلوب',
    postalCodeLength: 'يجب أن يتكون الرمز البريدي من 5 خانات بالضبط',
  },
}
